module.exports = __webpack_public_path__ + "static/media/b.00fa438f.svg";